<template>
  <div class="review-form">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <md-field title="申请成为Leader">
          <ValidationProvider name="姓名" rules="required" v-slot="{ errors }">
            <md-input-item
                    title="姓名"
                    placeholder="你的姓名"
                    v-model="post.name"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>
          <ValidationProvider name="联系电话" rules="required|mobile" v-slot="{ errors }">
            <md-input-item
                    title="电话"
                    placeholder="联系电话"
                    v-model="post.mobile"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>

        <ValidationProvider name="个人简介" rules="required|min:10" v-slot="{ errors }">
          <md-textarea-item
                  autosize
                  v-model="content"
                  placeholder="请输入你的个人简介"
                  :error="errors[0]"
          />
        </ValidationProvider>

        </md-field>

        <div class="btn-wrap">
          <md-button type="primary" native-type="submit">申请</md-button>
        </div>
      </form>
    </ValidationObserver>

  </div>
</template>

<script>
import { Field, FieldItem,TextareaItem,Button,InputItem } from 'mand-mobile'
//import imageProcessor from 'mand-mobile/lib/image-reader/image-processor'
import { ValidationProvider,ValidationObserver,extend } from 'vee-validate';
import { required,min } from 'vee-validate/dist/rules';
import Payment from '../components/Payment.vue';


extend('required', required);
extend('min', min);
extend('mobile', value => {
    if (/^(1\d{10}|1[\d-]{12})$/.test(value)) {
        return true;
    }

    return '请输入有效的手机号';
});

export default {
  name: "ReviewForm",
  components: {
      [Field.name]: Field,
      [FieldItem.name]: FieldItem,
      [TextareaItem.name]: TextareaItem,
      [InputItem.name]: InputItem,
      [Button.name]: Button,
      ValidationProvider,ValidationObserver
  },
  props: [],
  data() {
      return {
          starData:[],
          content:'',
          post:{name:"",mobile:""},
      }
  },
  methods: {
      onSubmit(e) {
          this.$toast.loading("提交中...");
          let post = {content:this.content, ...this.post};
          const referrer = localStorage.getItem('referrer');
          if(referrer && !isNaN(referrer))
              post.referrer_id = referrer;

          this.$http.post(`leader-applies`, post)
              .then(({data}) => {
                  console.log(data);
                  this.$toast.hide();
                  this.$dialog.alert({
                      title: '申请提交成功',
                      icon: 'success',
                      content: '工作人员将尽快与你联系',
                      confirmText: '确定',
                      onConfirm: () => {
                          this.$emit('onFormClose');
                      },
                  });
              })
              .catch(({response}) => {
                  console.log(response);
              })
      }
  }
};
</script>

<style lang="scss" scoped>
  .review-form {
    /*padding: 100px 20px 0;*/
  }
  .btn-wrap {padding: 30px;}
</style>

<style lang="stylus" scoped>
    .image-reader-list
      margin-top 30px
      float left
      width 100%
      .image-reader-item
        position relative
        float left
        width 23.5%
        padding-bottom 23.5%
        margin-bottom 2%
        margin-right 2%
        background #FFF
        box-shadow 0 5px 20px rgba(197, 202, 213, .25)
        box-sizing border-box
        list-style none
        border-radius 4px
        background-size cover
        overflow hidden
        &:nth-of-type(4n)
          margin-right 0
        &.add
          .md-icon
            position absolute
            top 40%
            left 50%
            transform translate(-50%, -50%)
            opacity .5
          p
            position absolute
            top 50%
            left 0
            width 100%
            margin-top 15px
            font-size 22px
            color #CCC
            text-align center
        .image-reader-item-del
          position absolute
          top 0
          right 0
          z-index 3
          opacity .8
          .md-icon-close
            font-size 24px
</style>
